<template>
    <div style="width: 100%;height: 400px;background-color: lightblue">
        {{title}}
    </div>
</template>

<script>
    import {ref,onMounted} from 'vue'

    export default {
        setup(){
            let state = ref('张大海');


            return (
                state
            )

        }
    }
    //往往是把一个功能的所有状态、方法、都封装到一个函数里面，方便统一管理；
    // 当我们哪个功能需要再其他组件被复用的时候，直接把相关的方法提取出去，然后再引用进来就可以了
    // 可以看出composition api的面向人群主要是经常写轮子或者框架的开发者，因为他更灵活，可以写出高内聚、低耦合的代码
    // 使用vue3的过程中也不是一定要用composition api的，如果业务不是很复杂使用option api也是没什么问题的。
   // Vue 3 是用ts 重构了，重点放在 diff 算法 和代码体积上下，API 上更新了option api， vue3 称之为composition api，compositionApi  的特点 是一个功能的所有状态、方法、都封装到一个函数里面，方便统一管理，或者写组件的时候，可以直接把方法提出去，更灵活一点，compositionApi更适合业务比较负咋的时候，或者组件高复用的时候可以选择性的使用compositionApi，一般业务使用vue2 的option api就可以了，写vue3的时候采用ts + optionApi 开发项目就行了
    function useCurrentFolderData(networkState) { // ...

    }
    function useFolderNavigation({ networkState, currentFolderData }) { // ...
    }

    function useFavoriteFolder(currentFolderData) { // ...
    }

    function useHiddenFolders() { // ...
    }

    function useCreateFolder(openFolder) { // ...
    }
</script>

